import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessOwnerSpeedDial.css';

import businessHub from '../assets/android/ui/p4r_business_hub.svg';
import profileIcon from '../assets/android/ui/p4r_business_profile_manage.svg';
import eventsIcon from '../assets/android/ui/p4r_business_events_manage.svg';
import adsIcon from '../assets/android/ui/p4r_business_ads_manage.svg';
import walletIcon from '../assets/android/ui/p4r_business_wallet_manage.svg';
const actions=[
  {key:'profile',label:'Manage profile',icon:profileIcon},
  {key:'events',label:'Manage events',icon:eventsIcon},
  {key:'ads',label:'Advertising',icon:adsIcon},
  {key:'wallet',label:'Wallet',icon:walletIcon},
];

export default function BusinessOwnerSpeedDial({visible=false}){
  const [open,setOpen]=useState(false);
  const rootRef=useRef(null);
  const navigate=useNavigate();
  useEffect(()=>{
    if(!open)return undefined;
    const close=e=>{if(!rootRef.current?.contains(e.target))setOpen(false);};
    document.addEventListener('pointerdown',close);
    return()=>document.removeEventListener('pointerdown',close);
  },[open]);
  if(!visible)return null;
  const go=tool=>{setOpen(false);navigate(`/business/manage?tool=${tool}`);};
  return <div className={`p4r-business-speed ${open?'is-open':''}`} ref={rootRef}>
    {open&&<div className="p4r-business-speed__actions" aria-label="Business actions">
      {actions.map(a=><button key={a.key} type="button" onClick={()=>go(a.key)}>
        <img src={a.icon} alt=""/><span>{a.label}</span>
      </button>)}
    </div>}
    <button type="button" className="p4r-business-speed__trigger" aria-expanded={open} aria-label="Business actions" onClick={()=>setOpen(v=>!v)}>
      <img src={businessHub} alt=""/>
    </button>
  </div>;
}
